<template>
  <div ref="container">
    <slot />
  </div>
</template>

<script>
/**
 * Outer container for rendering content onto the page sidebar
 * (the left side of the screen)
 *
 * SLOTS:
 * - default: content to display in the sidebar
 */
export default {
  mounted () {
    // When the component is mounted, we want to scroll the sidebar back to the top
    this.$refs.container.closest('.scroll').scrollTop = 0
  }
}
</script>
